import { REQUEST_IS_PENDING, LANGUAGE_CHANGE } from '../actions/commonsActions';

export const requestIsPending = (state = false, action) => {
	switch (action.type) {
		case REQUEST_IS_PENDING:
			return action.isPending;

		default:
			return state;
	}
};

export const languageReducer = (state = {lang: 'en'}, action) => {
	switch (action.type) {
	case LANGUAGE_CHANGE:
		return {
			...state,
			lang: action.payload.lang
		};

	default:
		return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/commons.js